import { Component } from '@angular/core'
import { ContentLayoutComponent } from '../content-layout.component'
import { NgClass, NgSwitch, NgSwitchCase } from '@angular/common';
import { Button } from 'primeng/button';
import { SidebarNotificationsComponent } from './side-bar-notifications/side-bar-notifications.component';
import { SidebarThemeConfigComponent } from './side-bar-theme-config/side-bar-theme-config.component';
import { SidebarProfileComponent } from './side-bar-profile/side-bar-profile.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './content-sidebar.component.html',
    standalone: true,
    imports: [
        NgClass,
        NgSwitch,
        Button,
        NgSwitchCase,
        SidebarNotificationsComponent,
        SidebarThemeConfigComponent,
        SidebarProfileComponent,
    ],
})
export class ContentSidebarComponent {
  constructor(public contentLayout: ContentLayoutComponent) {}
}
